export default "__VITE_ASSET__DwUajgUG__"